import { Route, Routes } from "react-router-dom";
import Courses from "../pages/Dashboard/Courses";
import AdminLayout from "../components/Layout/AdminLayout";
import AddLectures from "../pages/Dashboard/AddLectures";
import Students from "../pages/Dashboard/Students";
import AssignCourse from "../pages/Dashboard/AssignCourse";
import Faqs from "../pages/Dashboard/Faqs";
import AddQuiz from "../pages/Dashboard/AddQuiz";
import Instructors from "../pages/Dashboard/Instructors";
import UserProfile from "../pages/Dashboard/UserProfile";
import Reviews from "../pages/Dashboard/Reviews";
import Team from "../pages/Dashboard/Team";
import StudentsRequests from "../pages/Dashboard/StudentsRequests";
import DeleteQuiz from "../pages/Dashboard/DeleteQuiz";
import StudentProgress from "../pages/Dashboard/StudentProgress";
import Feedback from "../pages/Dashboard/Feedback";
import Annoucment from "../pages/Dashboard/Annoucment";
import Coupons from "../pages/Dashboard/Coupouns";
import Packages from "../pages/Dashboard/Packages";
import FreezeStudent from "../pages/Dashboard/FreezeStudent";
import Blogs from "../pages/Dashboard/Blogs";
import SupportCenter from "../pages/Dashboard/SupportCenter";
import Books from "../pages/Dashboard/Books";
import HostQuizs from "../pages/Dashboard/HostQuizs";
import QuestionBank from "../pages/Dashboard/QuestionBank";
import BookRequests from "../pages/Dashboard/BookRequests";
import EditCourseContent from "../pages/Dashboard/EditCourseContent";
import AddCourse from "../components/Dashboard/Courses/AddCourse";
import AddBlog from "../components/Blogs/AddBlog";
import AddBook from "../components/Dashboard/Books/AddBook";
import AddPackage from "../components/Dashboard/Courses/AddPackage";
import QuizGrades from "../pages/Dashboard/QuizGrades";
import Sales from "../pages/Dashboard/Sales";
import Consultants from "../pages/Dashboard/Consultants";
import AddNewConsultant from "../components/Consultancies/AddNewConsultant";
import Reservations from "../pages/Dashboard/Reservations";
import AddOfflineCourse from "../components/Dashboard/Courses/AddOfflineCourse";
import Training from "../pages/Dashboard/Training";
import AddOfflineLectures from "../pages/Dashboard/AddOfflineLecture";
import Mails from "../pages/Dashboard/Mails";
import AddIFRSQuiz from "../pages/Dashboard/AddIFRSQuiz";
import Categories from "../pages/Dashboard/Categories";
import ExamGenerator from "../pages/Dashboard/ExamGenerator";
import AddTopic from "../pages/Dashboard/AddTopic";
import AddMockup from "../pages/Dashboard/AddMockup";
import DeleteTopic from "../pages/Dashboard/DeleteTopic";
import DeleteMockup from "../pages/Dashboard/DeleteMockup";
import AddCertificate from "../components/Dashboard/Certificates/AddCertificate";
import SkipCourseQuiz from "../pages/Dashboard/SkipCourseQuiz";
import StudentAttemps from "../pages/Dashboard/StudentAttemps";
import Admins from "../pages/Dashboard/Admins";
import AddAdmin from "../components/Dashboard/Admin/AddAdmin";
const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/courses" element={<Courses />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/books" element={<Books />} />
        <Route path="/books/purchase-requests" element={<BookRequests />} />
        <Route path="/instructors" element={<Instructors />} />
        <Route path="/team" element={<Team />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/training" element={<Training />} />
        <Route
          path="/consultants/edit-consultant/:id"
          element={<AddNewConsultant />}
        />
        <Route
          path="/consultants/reservations/:id"
          element={<Reservations />}
        />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/sales" element={<Sales />} />
        <Route index path="/students" element={<Students />} />
        <Route path="/requests" element={<StudentsRequests />} />
        <Route path="/support" element={<SupportCenter />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/books/edit-book/:id" element={<AddBook />} />
        <Route path="/blogs/edit-blog/:id" element={<AddBlog />} />
        <Route path="/packages/edit-package/:id" element={<AddPackage />} />
        <Route path="/host-quizs" element={<HostQuizs />} />
        <Route path="/host-quizs/scores/:id" element={<QuizGrades />} />
        <Route path="/question-bank" element={<QuestionBank />} />
        <Route path="/assign-course" element={<AssignCourse />} />
        <Route path="/skip-quiz/:courseId" element={<SkipCourseQuiz />} />
        <Route
          path="/student-attemps/:studentId"
          element={<StudentAttemps />}
        />
        <Route path="/admins" element={<Admins />} />
        <Route path="/admins/create" element={<AddAdmin />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/announcement" element={<Annoucment />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/students/:id" element={<UserProfile />} />

        <Route path="/exam-maker" element={<ExamGenerator />} />
        <Route path="/exam-maker/add-topic/:id" element={<AddTopic />} />
        <Route path="/exam-maker/add-mockup/:id" element={<AddMockup />} />
        <Route path="/exam-maker/delete-topic/:id" element={<DeleteTopic />} />
        <Route
          path="/exam-maker/delete-mockups/:id"
          element={<DeleteMockup />}
        />
        <Route
          path="/exam-maker/edit-certificate/:id"
          element={<AddCertificate />}
        />

        <Route
          path="/courses/student-progress/:id"
          element={<StudentProgress />}
        />
        <Route
          path="/courses/edit-course-content/:id"
          element={<EditCourseContent />}
        />
        <Route path="/courses/edit-course/:id" element={<AddCourse />} />
        <Route
          path="/courses/edit-offline-course/:id"
          element={<AddOfflineCourse />}
        />
        <Route path="/courses/add-quiz/:id" element={<AddQuiz />} />
        <Route path="/courses/add-ifrs-quiz/:id" element={<AddIFRSQuiz />} />
        <Route path="/courses/delete-quiz/:id" element={<DeleteQuiz />} />
        <Route path="/courses/add-lecture/:id" element={<AddLectures />} />
        <Route
          path="/courses/add-offline-lecture/:id"
          element={<AddOfflineLectures />}
        />
        <Route path="/courses/freeze-student/:id" element={<FreezeStudent />} />

        <Route path="/mails" element={<Mails />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
